<div class="row">
  @if (labelName) {
    <div class="col-md-4 col-12">
      <label
        class="control-label"
        for="{{ labelName ? labelName : 'inputText' }}"
      >
        <span [ngClass]="required ? 'required' : 'hide'">*</span>
        {{ labelName }}
      </label>
    </div>
  }

  <div [ngClass]="{ 'col-md-8 col-12': labelName, 'col-12': !labelName }">
    <input
      (blur)="emitBlur()"
      (input)="onInput($event)"
      [dropSpecialCharacters]="false"
      [ngClass]="{
        requiredField: !isValid && !submitted && !isReadOnly,
        errorRequiredField: !isValid && submitted && !isReadOnly,
      }"
      [ngModel]="inputModel"
      [ngModelOptions]="{ standalone: true }"
      [showMaskTyped]="true"
      [validation]="required"
      autocomplete="tel"
      class="fixedWidth form-control"
      id="{{ labelName ? labelName : 'phoneNumber' }}"
      mask="(000) 000-0000"
      name="phoneNumber"
      placeholder="(___) ___-____"
      type="tel"
      [disabled]="isReadOnly"
    />
  </div>

  @if (environment.useDebugMode) {
    <pre>
      inputModel {{ inputModel }}
      isValid {{ isValid }}</pre>
  }
  @if (submitted && !isValid && !isReadOnly) {
    <div class="col-12 errorText" id="validationError">
      <i class="fa fa-circle-o fa-lg circle-position"></i>
      <i class="fa fa-exclamation exclamation-position"></i>
      <p class="col ps-2 ms-4 input-validation-text">
        Enter a valid phone number.
      </p>
    </div>
  }
  @if (!submitted || isValid || isReadOnly) {
    <div class="col-12">
      <p></p>
    </div>
  }
</div>
